import React, { FC } from 'react';
import styles from './ContentRuleCenterHeader.module.css';
import ContentRuleCenterIcon from '../../atoms/Icons/ContentRuleCenterIcon';
import Typography from '../../atoms/Typography';

export interface ContentRuleCenterHeaderProps {
  className?: string;
}

/**
 * ContentRuleCenterHeader - Header component for the Content Rule Center modal
 * Displays the title, subtitle, and icon
 */
const ContentRuleCenterHeader: FC<ContentRuleCenterHeaderProps> = ({
  className = '',
}) => {
  return (
    <div className={`${styles.header} ${className}`}>
      <div className={styles.textContent}>
        <Typography variant='display-lg' as='h2' className={styles.title}>
          Content Rule Center
        </Typography>
        <Typography variant='text-sm' as='p' className={styles.subtitle}>
          Manage and view content rules and quality checks.
        </Typography>
      </div>
      <div className={styles.iconWrapper}>
        <ContentRuleCenterIcon />
      </div>
    </div>
  );
};

ContentRuleCenterHeader.displayName = 'ContentRuleCenterHeader';

export default ContentRuleCenterHeader;
